<template>
  <div class="row">
    <div class="col-12">
      <div class="page_title">
        專刊資料確認
      </div>
    </div>
    <!-- <div class="col-12">
      <div class="page_info">
        專刊資料為報名廠商<span class="text-danger">必填</span>項目，各項目資料填完後才可往<span>下一步</span>報名其他活動哦！
      </div>
    </div> -->
    <div class="col-12">
      <special-issue-form
        :special-issue="initialEnterpriseData"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import { validationMixin } from 'vuelidate'
import SpecialIssueForm from '../common/SpecialIssueForm'
// import { specialIssueValidations } from './enrollment-process-validations'
export default {
  name: 'EnrollmentProcessSpecialIssue',
  components: {
    SpecialIssueForm
  },
  // mixins: [validationMixin],
  data () {
    return {
      initialEnterpriseData: {
        enterprise_services: '無',
        enterprise_related_company: '無',
        enterprise_recruiting_description: '無',
        enterprise_work_portfolio: '無'
      },
      currentEnterpriseData: {
      }
    }
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentEnterpriseGetter'
    ])
  },
  watch: {
    currentEnterpriseGetter (value) {
      this.initialEnterpriseData = Object.assign({}, {
        enterprise_hr_contact_person: value.enterprise_contact_person,
        enterprise_hr_contact_tel: value.enterprise_tel,
        enterprise_hr_contact_email: value.enterprise_contact_email
      }, value)
    }
  },
  // validations: specialIssueValidations,
  methods: {
    ...mapActions('pages/enterprises', [
      'updateOrder'
    ]),
    saveToStore () {
      // this.updateOrder({
      //   specialIssue: {}
      // })
    }
  }
}
</script>
